<!--
    描述：CA申请
    时间：2020/12/17
    Created by zl
    LastEditTime: 2022-4-21 16:25:52
    LastEditors: 钱磊

-->
<template>
	<div class="ca-layout">
		<div class="overflow-y">
			<div class="ca-header flex">
				<div class="upload-item">
					<public-upload
						ref="yyzzUpload"
						isViewMode
						:viewFilesList="viewFilesList"
						listType="picture-card"
						:isDisabled="true"
					></public-upload>
					<div class="top-item-text">
						<span style="color: red">*</span>
						统一社会信用代码证复印件<br />（需加盖公章）
					</div>
				</div>
				<div class="upload-item" v-if="this.applyType == 1">
					<!-- 企业委托书（盖章） -->
					<public-upload
						ref="sqhUpload"
						isViewMode
						:viewFilesList="viewFilesList"
						listType="picture-card"
						:isDisabled="true"
					></public-upload>
					<div class="top-item-text">
						<span style="color: red">*</span> 法人授权委托书 <br />
						（需加盖公章）
					</div>
				</div>
			</div>
			<div class="ca-content">
				<div class="list">
					<div class="header">单位及法人代表基本信息</div>
					<div class="content">
						<el-row>
							<el-col :span="12" class="msg-box">
								<span class="title">单位名称：</span>
								<span class="msg">
									{{ companyObj.tenantSname }}
								</span>
							</el-col>
							<el-col :span="12" class="msg-box">
								<span class="title">统一社会信用代码证：</span>
								<span class="msg">
									{{ companyObj.creditCode }}
								</span>
							</el-col>
							<el-col :span="12" class="msg-box">
								<span class="title">法人代表姓名：</span>
								<span class="msg">{{ companyObj.legal }}</span>
							</el-col>
							<el-col :span="12" class="msg-box">
								<span class="title">法人代表身份证号：</span>
								<span class="msg">
									{{ companyObj.legalNo }}
								</span>
							</el-col>
							<el-col :span="12" class="msg-box">
								<span class="title">法人代表手机号：</span>
								<span class="msg">
									{{ companyObj.legalPhone }}
								</span>
							</el-col>
						</el-row>
					</div>
				</div>
				<div class="list">
					<div class="header">经办人信息</div>
					<div class="content">
						<el-row>
							<el-col :span="12" class="msg-box">
								<span class="title">经办人姓名：</span>
								<span class="msg">{{ companyObj.sname }}</span>
							</el-col>
							<el-col :span="12" class="msg-box">
								<span class="title">经办人身份证号：</span>
								<span class="msg">{{ companyObj.idCard }}</span>
							</el-col>
							<el-col :span="12" class="msg-box">
								<span class="title">经办人手机号：</span>
								<span class="msg">{{ companyObj.phone }}</span>
							</el-col>
							<el-col :span="12" class="msg-box">
								<span class="title">经办人邮箱：</span>
								<span class="msg">{{ companyObj.email }}</span>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getRecordDetail } from 'api/modules/audit'
export default {
	props: {
		creditCode: {
			type: String,
			default: ''
		},
		tenantId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			dialogVisible: false,
			companyObj: {},
			applyType: '',
			viewFilesList: []
		}
	},
	created() {
		if (this.rowId == '') {
			this.goBack()
		} else {
			this.getCompanyMsg()
		}
	},
	methods: {
		// 获取公司信息
		getCompanyMsg() {
			getRecordDetail({
				recordId: this.rowId, //企业id，
				id: this.rowId
			}).then((res) => {
				this.companyObj = res.data.company
				this.viewFilesList = res.data.baseFiles
			})
		},

		// 返回
		goBack() {
			this.$router.push({ path: '/audit-affairs-new' })
		},

		// 审核
		approve() {
			this.dialogVisible = true
		},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		// 企业ID
		rowId() {
			return this.$route.query.id
		}
	}
}
</script>
<style lang="less" scoped>
.ca-layout {
	height: 100%;
	// padding: 20px 12px 60px 12px;
	padding: 20px 0;
	background-color: #fff;
	position: relative;

	.overflow-y {
		height: 100%;
		overflow-y: auto;
	}

	.ca-header {
		margin-bottom: 60px;
		padding-left: 50px;

		.upload-item {
			width: 220px;
			height: 123px;
			margin-right: 30px;
			/deep/ .upload-text {
				vertical-align: middle !important;
			}
			/deep/.el-upload-list__item {
				width: 220px !important;
				height: 123px !important;
			}
			/deep/.el-upload {
				width: 220px !important;
				height: 123px !important;
			}
			/deep/ .img-size {
				width: 220px !important;
				height: 123px !important;
			}
			/deep/ .el-upload__tip {
				display: none;
			}
		}

		.top-item-text {
			font-size: 12px;
			line-height: 20px;
			color: #666;
			text-align: center;
		}
	}

	.ca-content {
		.list {
			.header {
				padding-left: 12px;
				border-left: 4px solid #72aa2c;
				margin-bottom: 36px;
				font-size: 18px;
				font-weight: 400;
			}
			.content {
				margin-bottom: 36px;
				padding: 0 0 0 50px;
			}
		}
		.title {
			color: #666666;
			font-size: 14px;
			&::before {
				content: '*';
				color: #fc2828;
				margin-right: 4px;
			}
		}
		.msg {
			color: #202020;
			font-size: 14px;
			font-weight: bolder;
		}
		.msg-box {
			line-height: 30px;
		}
		.step {
			background-color: #f7f7f7;
			height: 130px;
			padding-top: 15px !important;
			padding-bottom: 15px !important;
		}
		.step-list {
			text-indent: 2rem;
			font-size: 14px;
			line-height: 25px;
			position: relative;
			&::before {
				content: '';
				display: block;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				background-color: #800080;
				position: absolute;
				left: 1rem;
				top: 8px;
			}
		}
	}
	.font16 {
		font-size: 16px;
	}
	/deep/ .el-upload--picture-card {
		line-height: 125px;
	}
	.footer {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		padding: 10px 0;
		background-color: #fff;
		box-shadow: 0px 0px 30px 0px rgba(201, 201, 201, 0.5);
		z-index: 3;
	}
	/deep/ .vxe-cell--title {
		color: #202020;
		font-weight: normal;
	}
}
</style>
